function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import twitter from './twitter';
export default _objectSpread({}, twitter, {
  // Add "now".
  steps: [{
    formatAs: 'now'
  }].concat(twitter.steps)
});
//# sourceMappingURL=twitterNow.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/javascript-time-ago/modules/style/twitterNow.js
// module id = 3260
// module chunks = 0